export const text = {
  title: 'Settings',
  subtitle: 'Manage your application preferences and garden defaults',
  appSectionTitle: 'App',
  signOut: 'Sign Out',
  backToSettings: 'Back to settings',
};
